import { observer } from 'mobx-react-lite'
import { type FC, useEffect } from 'react'
import classnames from 'classnames'
import { ContactsDetails } from 'widgets/ContactsDetails'
import { contactsDetailsGlobalStore } from 'widgets/ContactsDetails/store'
import type { SectionContactDetailsStore } from 'pages/conversations/pages/search/pages/profile/ui/SectionContactDetails'
import {
  ProviderSectionContactDetails,
  useSectionContactDetailsContext,
} from 'pages/conversations/pages/search/pages/profile/ui/SectionContactDetails/context/sectionContactDetailsContext'
import styles from './styles.module.scss'

const SectionContactDetailsContent = observer(() => {
  const { contactsDetailsStore, init, dispose, conversation } = useSectionContactDetailsContext()

  useEffect(() => {
    init()

    return () => {
      dispose()
    }
  }, [])

  if (!conversation) return null

  return (
    <div
      className={classnames(styles.wrap, {
        [styles['wrap--collapse']]: contactsDetailsGlobalStore.isCollapse,
      })}
    >
      {contactsDetailsStore && <ContactsDetails store={contactsDetailsStore} />}
    </div>
  )
})

type ISectionContactDetailsProps = {
  store: SectionContactDetailsStore
}

export const SectionContactDetails: FC<ISectionContactDetailsProps> = observer(({ store }) => {
  return (
    <ProviderSectionContactDetails value={store}>
      <SectionContactDetailsContent />
    </ProviderSectionContactDetails>
  )
})
